import {
  FileId,
  PayoutMethod,
  SocialLink,
  UserId,
  UrlHandleString,
  RoyaltySettings,
} from "kreate-common/modules/business-types";
import { z } from "zod";

// What users can update themselves.
// For instance, do not let users update their own userId!!
export const Params = z.object({
  displayName: z.string().optional(),
  headline: z.string().optional(),
  aboutDescription: z.string().optional(),
  avatarFileId: FileId.optional(),
  bannerFileId: FileId.optional(),
  payoutMethods: PayoutMethod.array().optional(),
  socialLinks: SocialLink.array().optional(),
  handle: UrlHandleString.nullish(),
  tags: z.string().array().nullish(),
  customUnsortedCollectionName: z.string().nullish(),
  walletAddresses: z.string().array().nullish(),
  // policy royalty for secondary marketplace
  defaultPolicyRoyalty: RoyaltySettings.nullish(),
});

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  userId: UserId,
});

export type Result = z.infer<typeof Result>;

export type UpdateUser$Params = Params;
export const UpdateUser$Params = Params;
export type UpdateUser$Result = Result;
export const UpdateUser$Result = Result;
